import React from "react";
import { useSEO } from "@/lib/seo";
import LeadForm from "@/components/common/LeadForm";
import { Breadcrumbs, SectionLabel } from "@/components/common/states";
import { CheckCircle2 } from "lucide-react";

const POINTS = [
  "We review your requirement within our advisory team",
  "We shortlist matching residential or commercial options",
  "We share details and arrange site visits for your favourites",
];

export default function Requirements() {
  useSEO({ title: "Tell Us Your Requirement", description: "Share your property requirement — budget, location, configuration and purpose — and get curated recommendations for Pune.", path: "/requirements" });
  return (
    <div className="ec-container py-8 sm:py-12">
      <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Requirements" }]} />
      <div className="mt-6 grid lg:grid-cols-2 gap-12 items-start">
        <div className="lg:sticky lg:top-28">
          <SectionLabel>Requirement</SectionLabel>
          <h1 className="font-display text-3xl sm:text-5xl text-foreground leading-tight">Tell us what you're looking for</h1>
          <p className="mt-4 text-muted-foreground text-lg max-w-md">
            The more you share, the better we can match you. It takes under a minute, and there's no obligation.
          </p>
          <ul className="mt-8 space-y-4">
            {POINTS.map((p) => (
              <li key={p} className="flex items-start gap-3 text-foreground/80"><CheckCircle2 className="h-5 w-5 text-primary shrink-0 mt-0.5" aria-hidden /> {p}</li>
            ))}
          </ul>
        </div>
        <div className="rounded-lg border border-border bg-white p-6 sm:p-8">
          <LeadForm source="requirement" variant="full" submitLabel="Get Property Recommendations" />
        </div>
      </div>
    </div>
  );
}
